module.exports = "/legacy/1c36d61ac5a5b615fb0d3acb53288ac5.svg";